import Cookies from 'js-cookie';
import ConstantApi from '../../../../ConstantApi';
import axiosCall, { ApiCallWithMessage } from '../../../axiosCall';
import { fetchPartyDetailsData } from '../../../partyDetails/partyDetails.action';
import { fetchCommonPropertyById } from '../../../property/common/commonProperty.actions';
import { fetchSeasonMaster } from '../../../seasonMaster/seasonMaster.actions';
import { fetchUnitMaster } from '../../../unitMaster/unitMaster.actions';
import {
    CREATE_YARN_PO_FAILURE,
    CREATE_YARN_PO_REQUEST,
    CREATE_YARN_PO_SUCCESS,
    CREATE_USER_FORM_YARN_PO,
    DELETE_YARN_PO_FAILURE,
    DELETE_YARN_PO_REQUEST,
    DELETE_YARN_PO_SUCCESS,
    FETCH_SINGLE_YARN_PO_FAILURE,
    FETCH_SINGLE_YARN_PO_REQUEST,
    FETCH_SINGLE_YARN_PO_SUCCESS,
    FETCH_YARN_PO_FAILURE,
    FETCH_YARN_PO_REQUEST,
    FETCH_YARN_PO_SUCCESS,
    YARN_PO_USERFORM_RESET,
    UPDATE_YARN_PO_FAILURE,
    UPDATE_YARN_PO_REQUEST,
    UPDATE_YARN_PO_SUCCESS,
    FETCH_YARN_PO_SECTION_LIST_REQUEST,
    FETCH_YARN_PO_SECTION_LIST_SUCCESS,
    FETCH_YARN_PO_SECTION_LIST_FAILURE,
    FETCH_YARN_PO_PROGRAM_LIST_REQUEST,
    FETCH_YARN_PO_PROGRAM_LIST_SUCCESS,
    FETCH_YARN_PO_PROGRAM_LIST_FAILURE,
    FETCH_YARN_PO_SALES_ORDER_REQUEST,
    FETCH_YARN_PO_SALES_ORDER_SUCCESS,
    FETCH_YARN_PO_SALES_ORDER_FAILURE,
    FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_REQUEST,
    FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_SUCCESS,
    FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_FAILURE,
    FETCH_YARN_PO_WITHOUT_FILTER_REQUEST,
    FETCH_YARN_PO_WITHOUT_FILTER_SUCCESS,
    FETCH_YARN_PO_WITHOUT_FILTER_FAILURE,
    YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    FETCH_YARN_PO_INVOICE_REQUEST,
    FETCH_YARN_PO_INVOICE_SUCCESS,
    FETCH_YARN_PO_INVOICE_FAILURE,
    FETCH_YARN_PO_UNIT_LIST_REQUEST,
    FETCH_YARN_PO_UNIT_LIST_SUCCESS,
    FETCH_YARN_PO_UNIT_LIST_FAILURE,
    FETCH_YARN_PO_SUPPLIER_LIST_REQUEST,
    FETCH_YARN_PO_SUPPLIER_LIST_SUCCESS,
    FETCH_YARN_PO_SUPPLIER_LIST_FAILURE,
    FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_REQUEST,
    FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_SUCCESS,
    FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_FAILURE,
    FETCH_YARN_LOTNO_INVOICE_REQUEST,
    FETCH_YARN_LOTNO_INVOICE_SUCCESS,
    FETCH_YARN_LOTNO_INVOICE_FAILURE,
    FETCH_YARN_PO_SUPPLIER_LIST2_REQUEST,
    FETCH_YARN_PO_SUPPLIER_LIST2_SUCCESS,
    FETCH_YARN_PO_SUPPLIER_LIST2_FAILURE,
    FETCH_YARN_PO_PENDING_SUPPLIER_LIST_REQUEST,
    FETCH_YARN_PO_PENDING_SUPPLIER_LIST_SUCCESS,
    FETCH_YARN_PO_PENDING_SUPPLIER_LIST_FAILURE,
    FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_REQUEST,
    FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_SUCCESS,
    FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_FAILURE,
    NAVIGATE_YARN_PO_DETAILS,
    DELETE_BTN_UPDATE_API_REQUEST,
    DELETE_BTN_UPDATE_API_SUCCESS,
    DELETE_BTN_UPDATE_API_FAILURE,
    OTP_API_POST_CLOSE_CALL_REQUEST,
    OTP_API_POST_CLOSE_CALL_SUCCESS,
    OTP_API_POST_CLOSE_CALL_FAILURE,
    OTP_API_POST_CLOSE_ALL_CALL_REQUEST,
    OTP_API_POST_CLOSE_ALL_CALL_SUCCESS,
    OTP_API_POST_CLOSE_ALL_CALL_FAILURE,
    CREATE_USER_FORM_PROGRAM_WISE_REPORT,
    FETCH_READYGARMENT_PO_SALES_ORDER_REQUEST,
    FETCH_READYGARMENT_PO_SALES_ORDER_SUCCESS,
    FETCH_READYGARMENT_PO_SALES_ORDER_FAILURE,
    EDIT_API_SELECTED_ROWS_CALL_REQUEST,
    EDIT_API_SELECTED_ROWS_CALL_SUCCESS,
    EDIT_API_SELECTED_ROWS_CALL_FAILURE,
} from './yarnPO.actionsType';
import Config from '../../../../config';
import axios from 'axios';

import { fetchFabricPoMasterData } from '../../FabricPo/fabricPoMaster/fabricPoMaster.action';
import moment from 'moment';

import { FETCH_SINGLE_STITCHING_DC_FAILURE, FETCH_SINGLE_STITCHING_DC_REQUEST, NAVIGATE_STITCHING_DC_DETAILS } from '../../StitchingDC/stitchingDC/stitchingDC.actionsType';
import { fetchKnittingDC } from '../../KnittingDC/knittingDC/knittingDC.actions';
import { fetchDyeingDC } from '../../DyeingDC/dyeingDC/dyeingDC.actions';
import { fetchCompactingDC } from '../../CompactingDC/compactingDC/compactingDC.actions';
import { fetchPrintingDC } from '../../AllOverPrintingDC/printingDC/printingDC.actions';
import { fetchStitchingDC } from '../../StitchingDC/stitchingDC/stitchingDC.actions';
import { fetchCuttingDC } from '../../CuttingDc/cuttingDC/cuttingDC.actions';
import { fetchIroningPackingDC } from '../../IroningPackingDC/IroningPackingDC/IroningPackingDC.actions';
import { getSingleGeneralPoMaster } from '../../GeneralPo/generalPoMaster/generalPoMaster.action';

import { getSingleGeneralPoMaster as getSingleGeneralDCMaster } from '../../GeneralDcNew/generalDcMaster/generalDcMaster.action';
import { fetchGarmentsPO } from '../../GarmentsPO/garmentsPO/garmentsPo.action';



// FETCH PROPERTY MASTER
export let fetchYarnPO = (startDate, endDate, unitId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnP0GET}?fromDate=${startDate}&toDate=${endDate}&FldFKUnitId=${-1}`,
        responseTypeRequest: FETCH_YARN_PO_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_FAILURE
    };
    return axiosCall(config);
};

// FETCH PROPERTY MASTER
export let fetchSupplierListBasedOnProgramDC = (controllerName) => {
    let config = {
        method: 'get',
        // url: `${ConstantApi.knittingDCMasterGET}`,
        url: `${ConstantApi.knittingDCSupplierListMasterGET}?FldControllerName=${controllerName}`,
        responseTypeRequest: FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_REQUEST,
        responseTypeSuccess: FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_SUCCESS,
        responseTypeFailure: FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_FAILURE
    };
    return axiosCall(config);
};

// FETCH PROPERTY MASTER
export let fetchYarnPOWithoutFilter = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnP0GET}`,
        responseTypeRequest: FETCH_YARN_PO_WITHOUT_FILTER_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_WITHOUT_FILTER_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_WITHOUT_FILTER_FAILURE
    };
    return axiosCall(config);
};

export let fetchUnitBasedOnUnitDropdown = (id) => {
    let companyID = Cookies.get('FKCompany')
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnPOUnitGET}?FldFKCompany=${companyID}`,
        responseTypeRequest: FETCH_YARN_PO_UNIT_LIST_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_UNIT_LIST_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_UNIT_LIST_FAILURE
    };
    return axiosCall(config);
};

export let fetchYarnPOSupplierDropdown = (controllerName) => {
    let config = {
        method: 'get',
        url: `/api/${controllerName}/GetLoadBuyerUsingFilter?FldControllerName=${controllerName}`,
        responseTypeRequest: FETCH_YARN_PO_SUPPLIER_LIST_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_SUPPLIER_LIST_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_SUPPLIER_LIST_FAILURE
    };
    return axiosCall(config);
};
export let fetchYarnPOSupplierDropdown2 = (controllerName) => {
    let config = {
        method: 'get',
        url: `/api/${controllerName}/GetLoadBuyerUsingFilter?FldControllerName=${controllerName}`,
        responseTypeRequest: FETCH_YARN_PO_SUPPLIER_LIST2_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_SUPPLIER_LIST2_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_SUPPLIER_LIST2_FAILURE
    };
    return axiosCall(config);
};

export let fetchYarnPOPendingSupplierDropdown = (programName) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnPOPendingSupplierGET}?ActionCode=${programName}`,
        responseTypeRequest: FETCH_YARN_PO_PENDING_SUPPLIER_LIST_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_PENDING_SUPPLIER_LIST_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_PENDING_SUPPLIER_LIST_FAILURE
    };
    return axiosCall(config);
};

export let fetchYarnPOPendingDeliveryAtDropdown = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnPOPendingDeliveryAtGET}`,
        responseTypeRequest: FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_FAILURE
    };
    return axiosCall(config);
};

// FETCH YARN PO SECTION LIST
export let fetchYarnPOSectionDropdown = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnPOSectionGET}/${id}`,
        responseTypeRequest: FETCH_YARN_PO_SECTION_LIST_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_SECTION_LIST_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_SECTION_LIST_FAILURE
    };
    return axiosCall(config);
};


// FETCH YARN PO SECTION LIST
export let fetchYarnPOProgramDropdown = (tableName) => {
    let config = {
        method: 'get',
        url: `/api/${tableName}/GetTblProgramList`,
        responseTypeRequest: FETCH_YARN_PO_PROGRAM_LIST_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_PROGRAM_LIST_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_PROGRAM_LIST_FAILURE
    };
    return axiosCall(config);
};

export let fetchYarnPOSalesOrderDropdown = (unitId, code) => {
    let keys = ['KNI', 'DYD', 'COMP', 'AOP']
    let currentCode = code === 'yarn' ? 'YARNPENDINGSALE' : code === 'WareHouseInward' ? 'PENDINGSALE4PKG' : code === 'fabric' ? 'FABRICPENDINGSALE0' : keys.includes(code) ? 'PENDINGSALEKG' : 'PENDINGSALE'
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnPOSalesOrderListNewApi}?FldAction=${currentCode}&UnitId=${unitId || 1}`,
        responseTypeRequest: FETCH_YARN_PO_SALES_ORDER_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_SALES_ORDER_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_SALES_ORDER_FAILURE
    };
    return axiosCall(config);
};

export let fetchReadyGarmentsPOSalesOrderDropdown = (unitId) => {

    let config = {
        method: 'get',
        url: `${ConstantApi.yarnPOSalesOrderListNewApi}?FldAction=PENDINGSALEGRP&UnitId=${unitId || 1}`,
        responseTypeRequest: FETCH_READYGARMENT_PO_SALES_ORDER_REQUEST,
        responseTypeSuccess: FETCH_READYGARMENT_PO_SALES_ORDER_SUCCESS,
        responseTypeFailure: FETCH_READYGARMENT_PO_SALES_ORDER_FAILURE
    };
    return axiosCall(config);
};

export let fetchPrintPartDCSalesOrderDropdown = (unitId) => {
    let config = {
        method: 'get',
        //PENDINGSALEPP
        url: `${ConstantApi.yarnPOSalesOrderListNewApi}?FldAction=PENDINGSALE&UnitId=${unitId}`,

        responseTypeRequest: FETCH_YARN_PO_SALES_ORDER_REQUEST,

        responseTypeSuccess: FETCH_YARN_PO_SALES_ORDER_SUCCESS,

        responseTypeFailure: FETCH_YARN_PO_SALES_ORDER_FAILURE
    };

    return axiosCall(config);
};

export let fetchYarnPOSalesOrderDropdown2 = (unitId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnPOSalesOrderListNewApi}?FldAction=PENDINGSALEPP&UnitId=${unitId}`,
        responseTypeRequest: FETCH_YARN_PO_SALES_ORDER_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_SALES_ORDER_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_SALES_ORDER_FAILURE
    };
    return axiosCall(config);
};

export let fetchYarnPOStyleNumberDropdown = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnPOStyleMasterList}/${id}`,
        responseTypeRequest: FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createYarnPoForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_YARN_PO, payload: { key, value } });
    };
};



export let createProgramWiseReportForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_PROGRAM_WISE_REPORT, payload: { key, value } });
    };
};

// CREATE PROPERTY MASTER
export let createYarnPo = (formData, modalClose, startDate, endDate, unitId, isDetail) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: 1 || parseInt(formData.fldFKDepartment),
        fldFKSaleOrderdetail: parseInt(formData.fldFKSaleOrderdetail),
        fldPoNo: 'Auto Generated',
        fldPoDate: today.toISOString(),
        fldDeliveryStartDate: formData.fldDeliveryStartDate || today.toISOString(),
        fldDeliveryEndDate: formData.fldDeliveryEndDate || today.toISOString(),
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? parseInt(formData.fldFKUnitId) : parseInt(formData.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(formData.fldFKDeliveryAt),
        fldNoofBags: parseInt(formData.fldNoofBags),
        fldTotalQty: parseInt(formData.fldTotalQty),
        fldInwardQty: 0,
        fldCancelQty: 0,
        fldBalanceQty: 0,
        fldPreparedBy: '',
        fldPrepareDate: today.toISOString(),
        fldVerifyBy: '',
        fldVerifyDate: today.toISOString(),
        fldAuthorizeBy: '',
        fldAuthorizeDate: today.toISOString(),
        fldInwardBy: '',
        fldInwardDate: today.toISOString(),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 11,
        fldCreatedDt: today.toISOString(),
        fldFKStatus: formData.fldFKStatus,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldApprovalStatus: 0,
        fldUnitCode: '',
        fldUnitName: '',
        fldUnitAddress1: '',
        fldUnitAddress2: '',
        fldUnitFKArea: 0,
        fldUnitCountry: '',
        fldUnitState: '',
        fldUnitCity: '',
        fldUnitArea: '',
        fldUnitPincode: '',
        fldUnitGSTNo: '',
        fldSupplierCode: '',
        fldSupplierName: '',
        fldSupplierAddress1: '',
        fldSupplierAddress2: '',
        fldSupplierFKArea: 0,
        fldSupplierCountry: '',
        fldSupplierState: '',
        fldSupplierCity: '',
        fldSupplierArea: '',
        fldSupplierPincode: '',
        fldSupplierGSTNo: '',
        fldDeliveryAtCode: '',
        fldDeliveryAtName: '',
        fldDeliveryAtAddress1: '',
        fldDeliveryAtAddress2: '',
        fldDeliveryAtFKArea: 0,
        fldDeliveryAtCountry: '',
        fldDeliveryAtState: '',
        fldDeliveryAtCity: '',
        fldDeliveryAtArea: '',
        fldDeliveryAtPincode: '',
        fldDeliveryAtGSTNo: '',
        fldFKSaleOrder: parseInt(formData.fldFKSaleOrder),
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldItemsGrossValue: parseInt(formData.fldItemsGrossValue),
        fldItemsTaxableValue: parseInt(formData.fldItemsTaxableValue),
        fldItemsGSTValue: parseInt(formData.fldItemsGSTValue),
        fldItemsTotalValue: parseInt(formData.fldItemsTotalValue),
        fldDiscountPercentage: parseInt(formData.fldDiscountPercentage),
        fldDiscountValue: parseInt(formData.fldDiscountValue),
        fldGrandGrossValue: parseInt(formData.fldGrandGrossValue),
        fldOtherPlusValue: parseInt(formData.fldOtherPlusValue),
        fldOtherMinusValue: parseInt(formData.fldOtherMinusValue),
        fldRoundoff: parseInt(formData.fldRoundoff),
        fldGrandTotalValue: parseInt(formData.fldGrandTotalValue),
        FldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms),
        fldReceivingNoofBags: 0,
        FldGenerateStyleDetailWise: formData.FldGenerateStyleDetailWise
    });
    // console.log('data :>> ', data);
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.yarnPOPOST}`,
        responseTypeRequest: CREATE_YARN_PO_REQUEST,
        responseTypeSuccess: CREATE_YARN_PO_SUCCESS,
        responseTypeFailure: CREATE_YARN_PO_FAILURE,
        resetFormData: isDetail ? YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB : YARN_PO_USERFORM_RESET,
        modalClose,
        PoDcInwardNo: 'fldPONO',
        PoDcInwardType: 'PO',
        isPopupOpen: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchYarnPO(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleYarnPO = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnPOGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_YARN_PO_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_YARN_PO_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_YARN_PO_FAILURE,
        singlApiArray: [
            // fetchSeasonMaster(),
            // fetchPartyDetailsData(),
            // fetchCommonPropertyById(52),
            // fetchCommonPropertyById(46),
            // fetchCommonPropertyById(28),
            // fetchUnitMaster(),
            // fetchYarnPOProgramDropdown('TblYarnPO'),
            // fetchYarnPOSupplierDropdown('TblYarnPO'),
            // fetchYarnPOSupplierDropdown2('TblProgramSupplier')
            // fetchYarnPOSalesOrderDropdown()
        ]
    };
    return axiosCall(config);
};

export let getSingleYarnPoForApprovalStatus = (id, navigateDetail, requestFailure, request, url, DCSelectedValue, fnCall) => {
    return (dispatch) => {
        dispatch({ type: request });
        var config = {
            method: 'get',
            url: `${Config.baseUrl}${url}/${id}`,
            headers: {
                // 'Access-Control-Allow-Origin': true,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                dbname: Cookies.get('DATABASE')
            }
        };
        axios(config)
            .then((response) => {
                // console.log('responsefast', response)
                // console.log('response2222', navigateDetail)
                // console.log('DCSelectedValue', DCSelectedValue)

                if (navigateDetail === 'NAVIGATE_STITCHING_DC_DETAILS') {
                    dispatch({
                        type: navigateDetail,
                        payload: 'details',
                        updatePayload: { [DCSelectedValue]: response.data }

                    });
                } else {
                    setTimeout(() => {
                        dispatch({
                            type: navigateDetail,
                            updatePayload: { [DCSelectedValue]: response.data }
                        });
                    }, 1000)

                }
                if (navigateDetail === 'NAVIGATE_GENERAL_PO_DETAILS') {
                    dispatch(getSingleGeneralPoMaster(id))
                } else if (navigateDetail === 'NAVIGATE_GENERAL_DC_DETAILS') {
                    dispatch(getSingleGeneralDCMaster(id))
                }

                // will check later for this method
                // dispatch(fn(id))

                fnCall()


            })
            .catch((error) => {
                dispatch({ type: requestFailure, updatePayload: error });
            });
    };
};

// export let getSingleKnittingPoForApprovalStatus = (id) => {
//     return (dispatch) => {
//         dispatch({ type: FETCH_SINGLE_KNITTING_DC_REQUEST });
//         var config = {
//             method: 'get',
//             url: `${Config.baseUrl}${ConstantApi.knittingDCMasterGETID}/${id}`,
//             headers: {
//                 // 'Access-Control-Allow-Origin': true,
//                 'Content-Type': 'application/json',
//                 Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
//                 dbname: Cookies.get('DATABASE')
//             }
//         };
//         axios(config)
//             .then((response) => {
//                 dispatch({
//                     type: NAVIGATE_KNITTING_DC_DETAILS,
//                     updatePayload: { knittingDCSelectedValue: response.data }
//                 });
//             })
//             .catch((error) => {
//                 dispatch({ type: FETCH_SINGLE_KNITTING_DC_FAILURE, updatePayload: error });
//             });
//     };
// };

// export let getSingleDyeingPoForApprovalStatus = (id) => {
//     return (dispatch) => {
//         dispatch({ type: FETCH_SINGLE_DYEING_DC_REQUEST });

//         var config = {
//             method: 'get',
//             url: `${Config.baseUrl}${ConstantApi.dyeingDCMasterGETID}/${id}`,
//             headers: {
//                 // 'Access-Control-Allow-Origin': true,
//                 'Content-Type': 'application/json',
//                 Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
//                 dbname: Cookies.get('DATABASE')
//             }
//         };
//         axios(config)
//             .then((response) => {
//                 dispatch({
//                     type: NAVIGATE_DYEING_DC_DETAILS,
//                     updatePayload: { dyeingDCSelectedValue: response.data }
//                 });
//             })
//             .catch((error) => {
//                 dispatch({ type: FETCH_SINGLE_DYEING_DC_FAILURE, updatePayload: error });
//             });
//     };
// };

// export let getSingleCompactingPoForApprovalStatus = (id) => {
//     return (dispatch) => {
//         dispatch({ type: FETCH_SINGLE_COMPACTING_DC_REQUEST });
//         var config = {
//             method: 'get',
//             url: `${Config.baseUrl}${ConstantApi.compactingDCMasterGETID}/${id}`,
//             headers: {
//                 // 'Access-Control-Allow-Origin': true,
//                 'Content-Type': 'application/json',
//                 Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
//                 dbname: Cookies.get('DATABASE')
//             }
//         };
//         axios(config)
//             .then((response) => {
//                 dispatch({
//                     type: NAVIGATE_COMPACTING_DC_DETAILS,
//                     updatePayload: { compactingDCSelectedValue: response.data }
//                 });
//             })
//             .catch((error) => {
//                 dispatch({ type: FETCH_SINGLE_COMPACTING_DC_FAILURE, updatePayload: error });
//             });
//     };
// };

// export let getSingleAllOverPrintingPoForApprovalStatus = (id) => {
//     return (dispatch) => {
//         dispatch({ type: FETCH_SINGLE_ALL_OVER_PRINTING_DC_DETAILS_REQUEST });
//         var config = {
//             method: 'get',
//             url: `${Config.baseUrl}${ConstantApi.printingDCMasterGETID}/${id}`,
//             headers: {
//                 // 'Access-Control-Allow-Origin': true,
//                 'Content-Type': 'application/json',
//                 Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
//                 dbname: Cookies.get('DATABASE')
//             }
//         };
//         axios(config)
//             .then((response) => {
//                 dispatch({
//                     type: NAVIGATE_ALL_OVER_PRINTING_DC_DETAILS,
//                     updatePayload: { printingDCSelectedValue: response.data }
//                 });
//             })
//             .catch((error) => {
//                 dispatch({ type: FETCH_SINGLE_ALL_OVER_PRINTING_DC_DETAILS_FAILURE, updatePayload: error });
//             });
//     };
// };

// export let getSingleCuttingPoForApprovalStatus = (id) => {
//     return (dispatch) => {
//         dispatch({ type: FETCH_SINGLE_CUTTING_DC_REQUEST });
//         var config = {
//             method: 'get',
//             url: `${Config.baseUrl}${ConstantApi.cuttingDCMasterGETID}/${id}`,
//             headers: {
//                 // 'Access-Control-Allow-Origin': true,
//                 'Content-Type': 'application/json',
//                 Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
//                 dbname: Cookies.get('DATABASE')
//             }
//         };
//         axios(config)
//             .then((response) => {
//                 dispatch({
//                     type: NAVIGATE_CUTTING_DC_DETAILS,
//                     updatePayload: { cuttingDCSelectedValue: response.data }
//                 });
//             })
//             .catch((error) => {
//                 dispatch({ type: FETCH_SINGLE_CUTTING_DC_FAILURE, updatePayload: error });
//             });
//     };
// };


export let getSingleStichingPoForApprovalStatus = (id) => {
    return (dispatch) => {
        dispatch({ type: FETCH_SINGLE_STITCHING_DC_REQUEST });
        var config = {
            method: 'get',
            url: `${Config.baseUrl}${ConstantApi.stichingDCMasterGETID}/${id}`,
            headers: {
                // 'Access-Control-Allow-Origin': true,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                dbname: Cookies.get('DATABASE')
            }
        };
        axios(config)
            .then((response) => {
                dispatch({
                    type: NAVIGATE_STITCHING_DC_DETAILS,
                    updatePayload: { stitchingDCSelectedValue: response.data }
                });
            })
            .catch((error) => {
                dispatch({ type: FETCH_SINGLE_STITCHING_DC_FAILURE, updatePayload: error });
            });
    };
};


// export let getSinglefabricPoForApprovalStatus = (id) => {
//     return (dispatch) => {
//         dispatch({ type: FETCH_FABRIC_PO_DETAILS_REQUEST });
//         var config = {
//             method: 'get',
//             url: `${Config.baseUrl}${ConstantApi.fabricPOGETID}/${id}`,
//             headers: {
//                 // 'Access-Control-Allow-Origin': true,
//                 'Content-Type': 'application/json',
//                 Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
//                 dbname: Cookies.get('DATABASE')
//             }
//         };
//         axios(config)
//             .then((response) => {
//                 dispatch({
//                     type: NAVIGATE_FABRIC_PO_DETAILS,
//                     updatePayload: { singleFabricPoData: response.data }
//                 });
//             })
//             .catch((error) => {
//                 dispatch({ type: FETCH_FABRIC_PO_DETAILS_FAILURE, updatePayload: error });
//             });
//     };
// };

export let getYarnPOInvoiceDataV2 = (id, iAction) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnP0InvoiceGET}?FldId=${id}&mAction=${iAction}`,
        responseTypeRequest: FETCH_YARN_PO_INVOICE_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_INVOICE_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_INVOICE_FAILURE
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER
export let updateYarnPO = (formData, id, startDate, endDate, unitId, updateMode) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: parseInt(id),
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: 1 || parseInt(formData.fldFKDepartment),
        fldPoNo: formData.fldPoNo,
        fldPoDate: formData?.fldPoDate || today.toISOString(),
        fldDeliveryStartDate: formData.fldDeliveryStartDate,
        fldFKSaleOrderdetail: parseInt(formData.fldFKSaleOrderdetail),
        fldDeliveryEndDate: formData.fldDeliveryEndDate,

        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? 0 : parseInt(formData.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(formData.fldFKDeliveryAt),
        fldNoofBags: Number(formData.fldNoofBags),
        fldTotalQty: Number(formData.fldTotalQty),
        fldInwardQty: Number(formData.fldInwardQty),
        fldCancelQty: Number(formData.fldCancelQty),
        fldBalanceQty: Number(formData.fldBalanceQty),

        // fldVerifyBy: '',
        // fldVerifyDate: today.toISOString(),
        // fldAuthorizeBy: '',
        // fldAuthorizeDate: today.toISOString(),
        fldInwardBy: '',
        fldInwardDate: today.toISOString(),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldPreparedBy: formData.fldPreparedBy,
        fldPrepareDate: formData.fldPrepareDate,
        fldModifiedBy: 11,
        fldModifiedDt: today.toISOString(),
        fldFKStatus: formData.fldFKStatus,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldApprovalStatus: formData.fldApprovalStatus,
        fldUnitCode: '',
        fldUnitName: '',
        fldUnitAddress1: '',
        fldUnitAddress2: '',
        fldUnitFKArea: 0,
        fldUnitCountry: '',
        fldUnitState: '',
        fldUnitCity: '',
        fldUnitArea: '',
        fldUnitPincode: '',
        fldUnitGSTNo: '',
        fldSupplierCode: '',
        fldSupplierName: '',
        fldSupplierAddress1: '',
        fldSupplierAddress2: '',
        fldSupplierFKArea: 0,
        fldSupplierCountry: '',
        fldSupplierState: '',
        fldSupplierCity: '',
        fldSupplierArea: '',
        fldSupplierPincode: '',
        fldSupplierGSTNo: '',
        fldDeliveryAtCode: '',
        fldDeliveryAtName: '',
        fldDeliveryAtAddress1: '',
        fldDeliveryAtAddress2: '',
        fldDeliveryAtFKArea: 0,
        fldDeliveryAtCountry: '',
        fldDeliveryAtState: '',
        fldDeliveryAtCity: '',
        fldDeliveryAtArea: '',
        fldDeliveryAtPincode: '',
        fldDeliveryAtGSTNo: '',
        fldFKSaleOrder: parseInt(formData.fldFKSaleOrder),
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldItemsGrossValue: parseInt(formData.fldItemsGrossValue),
        fldItemsTaxableValue: parseInt(formData.fldItemsTaxableValue),
        fldItemsGSTValue: parseInt(formData.fldItemsGSTValue),
        fldItemsTotalValue: parseInt(formData.fldItemsTotalValue),
        fldDiscountPercentage: parseInt(formData.fldDiscountPercentage),
        fldDiscountValue: parseInt(formData.fldDiscountValue),
        fldGrandGrossValue: parseInt(formData.fldGrandGrossValue),
        fldOtherPlusValue: parseInt(formData.fldOtherPlusValue),
        fldOtherMinusValue: parseInt(formData.fldOtherMinusValue),
        fldRoundoff: parseInt(formData.fldRoundoff),
        fldGrandTotalValue: parseInt(formData.fldGrandTotalValue),
        FldReceivingNoofBags: formData.fldReceivingNoofBags,
        FldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms),

        fldIsPrepared: formData.fldIsPrepared,

        fldPreparedOn: formData.fldPreparedOn,

        fldIsVerified: formData.fldIsVerified,

        fldVerifiedBy: formData.fldVerifiedBy,

        fldVerifiedOn: formData.fldVerifiedOn,

        fldIsAuthorized: formData.fldIsAuthorized,

        fldAuthorizedBy: formData.fldAuthorizedBy,

        fldAuthorizedOn: formData.fldAuthorizedOn,

        fldVerifyBy: formData.fldVerifyBy,
        fldVerifyDate: formData.fldVerifyDate,
        fldAuthorizeBy: formData.fldAuthorizeBy,
        fldAuthorizeDate: formData.fldAuthorizeDate,
        FldGenerateStyleDetailWise: formData.FldGenerateStyleDetailWise,
        fldReason: formData.fldReason
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.yarnPOPATCH}/${id}?FldApprovalStatus=${parseInt(formData.fldApprovalStatus)}&SUpdateMode=${updateMode}`,
        responseTypeRequest: UPDATE_YARN_PO_REQUEST,
        responseTypeSuccess: UPDATE_YARN_PO_SUCCESS,
        responseTypeFailure: UPDATE_YARN_PO_FAILURE,
        resetFormData: YARN_PO_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchYarnPO(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteYarnPO = (id, startDate, endDate, unitId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.yarnPODELETE}/${id}`,
        responseTypeRequest: DELETE_YARN_PO_REQUEST,
        responseTypeSuccess: DELETE_YARN_PO_SUCCESS,
        responseTypeFailure: DELETE_YARN_PO_FAILURE,
        modalClose: true,
        getAllData: fetchYarnPO(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

export let getYarnLotNoInvoiceData = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnLotNoInvoiceGET}/${id}`,
        responseTypeRequest: FETCH_YARN_LOTNO_INVOICE_REQUEST,
        responseTypeSuccess: FETCH_YARN_LOTNO_INVOICE_SUCCESS,
        responseTypeFailure: FETCH_YARN_LOTNO_INVOICE_FAILURE
    };
    return axiosCall(config);
};

export let updateApiWhileDeletingCall = (id) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.updateDeleteApiCall}/${id}`,
        responseTypeRequest: DELETE_BTN_UPDATE_API_REQUEST,
        responseTypeSuccess: DELETE_BTN_UPDATE_API_SUCCESS,
        responseTypeFailure: DELETE_BTN_UPDATE_API_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config);
};

export let deleteApiCallWithReason = (id, reason, status, startDate, endDate, unitId) => {
    let yarnPo = `${ConstantApi.deleteYarnPoApiCall}?FldId=${id}&FldReason=${reason}`;
    let fabricPo = `${ConstantApi.deletefabricPoApiCall}?FldId=${id}&FldReason=${reason}`;
    let knittingPo = `${ConstantApi.deleteKnittingPoApiCall}?FldId=${id}&FldReason=${reason}`;
    let dyeingPo = `${ConstantApi.deleteDyeingPoApiCall}?FldId=${id}&FldReason=${reason}`;
    let compacting = `${ConstantApi.deleteCompactingPoApiCall}?FldId=${id}&FldReason=${reason}`;

    let allOverPrint = `${ConstantApi.deleteAllOverPrintApiCall}?FldId=${id}&FldReason=${reason}`;

    // let stitchingDc = `${ConstantApi.deleteStitchingApiCall}?FldId=${id}&FldReason=${reason}`;
    let stitchingDc = `${ConstantApi.deleteStitchingApiCallDelete}/${id}`;



    let cuttingDc = `${ConstantApi.deleteCuttingApiCall}/${id}`;
    // let ironingDc = `${ConstantApi.deleteIroningApiCall}?FldId=${id}&FldReason=${reason}`;
    let ironingDc = `${ConstantApi.deleteIroningApiCallDelete}/${id}`;
    let garmentPo = `${ConstantApi.garmentPoCallOff}/${id}`;




    let config = {
        method: status === 'STD' || status === 'IPD' ? 'delete' : 'patch',
        url: status === 'YAN' ? yarnPo : status === 'FAB' ? fabricPo : status === 'KNI' ? knittingPo : status === 'DYD' ? dyeingPo : status === 'COMP' ? compacting : status === 'STD' ? stitchingDc : status === 'CUD' ? cuttingDc : status === 'IPD' ? ironingDc : status === 'GAP' ? garmentPo : allOverPrint,
        responseTypeRequest: DELETE_BTN_UPDATE_API_REQUEST,
        responseTypeSuccess: DELETE_BTN_UPDATE_API_SUCCESS,
        responseTypeFailure: DELETE_BTN_UPDATE_API_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: status === 'FAB'
            ? fetchFabricPoMasterData(moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), unitId)
            : status === 'YAN' ? fetchYarnPO(moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), unitId) : status === 'KNI' ? fetchKnittingDC(moment(startDate).format('YYYY-MM-DD'),
                moment(endDate).format('YYYY-MM-DD'),
                unitId) : status === 'DYD' ? fetchDyeingDC(
                    moment(startDate).format('YYYY-MM-DD'),
                    moment(endDate).format('YYYY-MM-DD'),
                    unitId
                ) : status === 'COMP' ? fetchCompactingDC(
                    moment(startDate).format('YYYY-MM-DD'),
                    moment(endDate).format('YYYY-MM-DD'),
                    unitId
                ) : status === 'STD' ?
                fetchStitchingDC(
                    moment(startDate).format('YYYY-MM-DD'),
                    moment(endDate).format('YYYY-MM-DD'),
                    unitId
                ) : status === 'CUD' ?
                    fetchCuttingDC(
                        moment(startDate).format('YYYY-MM-DD'),
                        moment(endDate).format('YYYY-MM-DD'),
                        unitId
                    )

                    : status === 'IPD' ?
                        fetchIroningPackingDC(
                            moment(startDate).format('YYYY-MM-DD'),
                            moment(endDate).format('YYYY-MM-DD'),
                            unitId
                        )
                        :
                        status === 'GAP' ?

                            fetchGarmentsPO(moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), unitId)
                            :
                            fetchPrintingDC(
                                moment(startDate).format('YYYY-MM-DD'),
                                moment(endDate).format('YYYY-MM-DD'),
                                unitId
                            )


    };
    return axiosCall(config, true);
};
// https://localhost:44396/api/TblYarnPO/UpdateTblYarnPOApproval?FldId=30&ApprovalStatus=2&ProgramCode=FAP

export const otpCloseApiCall = (id, unique) => {
    let config = {
        method: 'post',
        // url: status ? fabricPo : yarnPo,
        url: `${ConstantApi.postOtpCallPostYarn}=${id}&ActionCode=${unique}`,
        responseTypeRequest: OTP_API_POST_CLOSE_CALL_REQUEST,
        responseTypeSuccess: OTP_API_POST_CLOSE_CALL_SUCCESS,
        responseTypeFailure: OTP_API_POST_CLOSE_CALL_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config);
};

export const otpCloseAllApiCall = (id, unique) => {
    let config = {
        method: 'post',
        url: `${ConstantApi.postOtpCloseCallPostYarn}?FldFKPONO=${id}&ActionCode=${unique}`,
        responseTypeRequest: OTP_API_POST_CLOSE_ALL_CALL_REQUEST,
        responseTypeSuccess: OTP_API_POST_CLOSE_ALL_CALL_SUCCESS,
        responseTypeFailure: OTP_API_POST_CLOSE_ALL_CALL_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config);
};

export const editSelectedRowsGet = (id) => {

    let config = {
        method: 'get',
        url: `${ConstantApi.editPrevListGet}/${id}`,
        responseTypeRequest: EDIT_API_SELECTED_ROWS_CALL_REQUEST,
        responseTypeSuccess: EDIT_API_SELECTED_ROWS_CALL_SUCCESS,
        responseTypeFailure: EDIT_API_SELECTED_ROWS_CALL_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config);
}